import React, { createContext, useContext } from 'react';

import { noop } from 'utils/helpers';

import { StoryInventoryItemBlockProps } from 'types/Story';

type ContentBlockItemContext = 'SINGLE' | 'MULTI';

type ContentBlockItemConfig = {
  item: StoryInventoryItemBlockProps;
  updateItem(item: StoryInventoryItemBlockProps): void;
  removeItem(): void;
  context: ContentBlockItemContext;
};

const ContentItemContext = createContext<ContentBlockItemConfig>({
  item: {
    id: 'initial-id',
    state: 'EMPTY',
  },
  updateItem: noop,
  removeItem: noop,
  context: 'SINGLE',
});

export const useContentItemNftContext = () => useContext(ContentItemContext);

function ContentItemContextProvider(props: {
  item: StoryInventoryItemBlockProps;
  children: React.ReactNode;
  updateItem(item: StoryInventoryItemBlockProps): void;
  removeItem(): void;
  context: ContentBlockItemContext;
}) {
  const { item, updateItem, removeItem, context } = props;

  return (
    <ContentItemContext.Provider
      value={{
        item,
        context,
        updateItem,
        removeItem,
      }}
    >
      {props.children}
    </ContentItemContext.Provider>
  );
}

export const ContentBlockItemNft = {
  Provider: ContentItemContextProvider,
};
